import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { RestaurantFormData } from "@/types/restaurantForm";

interface WebsiteFieldProps {
  form: UseFormReturn<RestaurantFormData>;
}

export const WebsiteField = ({ form }: WebsiteFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="website"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Website</FormLabel>
          <FormControl>
            <Input {...field} placeholder="www.restaurant.com" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};